import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://oil-gas-2jq5.onrender.com/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// News API
export const newsAPI = {
  getAll: () => api.get('/news'),
};

// Vacancies API
export const vacanciesAPI = {
  getAll: () => api.get('/vacancies'),
  getById: (id: number) => api.get(`/vacancies/${id}`),
  search: (query: string) => api.get(`/vacancies/search/${query}`),
};

// History API
export const historyAPI = {
  getAll: () => api.get('/history'),
  getTimeline: () => api.get('/history/timeline'),
  getFigures: () => api.get('/history/figures'),
  getMilestones: () => api.get('/history/milestones'),
  getImpact: () => api.get('/history/impact'),
};

// Reserves API
export const reservesAPI = {
  getAll: () => api.get('/reserves'),
  getOverview: () => api.get('/reserves/overview'),
  getBlocks: () => api.get('/reserves/blocks'),
  getCompanies: () => api.get('/reserves/companies'),
  getOwnership: () => api.get('/reserves/ownership'),
  getCompanyByName: (name: string) => api.get(`/reserves/companies/${name}`),
};

// Contractors API
export const contractorsAPI = {
  getAll: () => api.get('/contractors'),
  getCategories: () => api.get('/contractors/categories'),
  getByCategory: (category: string) => api.get(`/contractors/categories/${category}`),
  getResources: () => api.get('/contractors/resources'),
  getGovernmentResources: () => api.get('/contractors/resources/government'),
  getTrainingResources: () => api.get('/contractors/resources/training'),
  getAssociations: () => api.get('/contractors/resources/associations'),
  search: (query: string) => api.get(`/contractors/search/${query}`),
};

export default api;
